import { Category } from '@synergy/models';

import { unique } from './unique';

export const getFilteredCategoryIds = (categories: Category[], search?: string | null): number[] | undefined => {
    if (!search) {
        return undefined;
    }

    const getParentIds = (category: Category, cats: Category[]): number[] => {
        let result: number[] = [];
        if (category.parentId) {
            result.push(category.parentId);
            const parent = cats.find(cat => cat.id === category.parentId);
            if (parent?.parentId) {
                result = result.concat(getParentIds(parent, cats));
            }
        }
        return result;
    };

    let filterIds: number[] = [];
    const searchResults = categories.filter(category =>
        Object.values(category.translations).find(translation =>
            translation.toLowerCase().includes(search.toLowerCase())
        )
    );
    filterIds = filterIds.concat(searchResults.map(result => result.id));
    searchResults.forEach(result => {
        filterIds = filterIds.concat(getParentIds(result, categories));
    });
    filterIds = unique(filterIds);
    return filterIds;
};
